module.exports = __webpack_public_path__ + "img/image.0b677587.png";